import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1366,
      xl: 1536,
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#336B7B",
      dark: "#000000",
    },
    secondary: {
      main: "#282956",
    },
    info: {
      main: "#ffffff",
      dark: "#707070",
    },
    error: {
      main: "#DB364F",
    },
    success: {
      main: "#50B67A",
    },
  },
  typography: {
    h1: {
      fontSize: 36,
    },
    h2: {
      fontSize: 32,
    },
    h3: {
      fontSize: 28,
    },
    h4: {
      fontSize: 24,
    },
    h5: {
      fontSize: 22,
    },
    h6: {
      fontSize: 20,
    },
    fontSize: 18,
    fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
    htmlFontSize: 18,
  },

  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "black",
          fontSize: 16,
        },
        formControl: {
          fontSize: 16,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "black",
          fontSize: 16,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          color: "black",
          fontSize: 24,
          fontWeight: "bold",
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: {
          color: "black",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
      },
    },
  },
});

export default theme;
